import * as React from 'react';
import {
  Button as RACButton,
  ButtonProps as RACButtonProps,
} from 'react-aria-components';

import { type VariantProps } from 'tailwind-variants';
import { cn } from '@/lib/utils';

import { buttonVariants } from './button-variants';

export type ButtonProps = Omit<RACButtonProps, 'isDisabled'> &
  VariantProps<typeof buttonVariants> & {
    isLoading?: boolean;
    children?: React.ReactNode;
    icon?: React.ReactNode;
    className?: string;
    isDisabled?: boolean;
  };

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      variant,
      children,
      size,
      isLoading,
      icon,
      isDisabled,
      ...props
    },
    ref
  ) => {
    return (
      <RACButton
        className={cn(buttonVariants({ variant, size }), className)}
        ref={ref}
        isPending={isLoading}
        isDisabled={isDisabled}
        {...props}
      >
        {children}
        {icon && <span>{icon}</span>}
      </RACButton>
    );
  }
);

Button.displayName = 'Button';

export default Button;
